import { Box, Stack } from "@mui/material";
import { GetStaticPaths, GetStaticProps } from "next";
import Head from "next/head";

import {
  // DTypeCTA,
  DTypeBreadCrumb,
  // BTypeTabsFacility,
  DefaultFacility,
  ETypeFacilityMainHead,
  // FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  buildFacilityPageSchema,
  GOI_WEB_URL,
  RichSearch,
  ParlorHeadSection,
  colors,
  BTypeMap,
  BTypeTabsFacility,
  BTypeFacilityList,
  BTypeFacilityFAQ,
  FacilityDetailFAQ,
  DTypeCTA,
  excludeFacilities,
  FacilityHiddenNotice,
  getFacilityTypeLabel,
  getFacilityDisplayName,
  getFacilityRegionKeyword,
} from "goi_common";
import facilities from "goi_common/src/constants/facilities_detail.json";

import { parlorRegion } from "@/constants/parlorRegion";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((facility) => targetSidos.includes(facility.sido))
    .map((facility) => ({
      params: {
        id: String(facility.id),
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = params?.id as string;

  const p_facility = facilities.find(
    (facility) => Number(facility.id) === Number(id)
  ) as DefaultFacility;

  id === "232" && console.log(p_facility);

  const { address, companyname, images, type } = p_facility;
  const typeLabel = getFacilityTypeLabel(type);
  const displayName = getFacilityDisplayName(companyname, type);
  const regionKeyword = getFacilityRegionKeyword(type);

  const 시가아닌_도인경우 = address.split(" ")[0].length == 4;
  const district = 시가아닌_도인경우
    ? address[0] + address[2]
    : address.slice(0, 2);

  const title = `[${district}] ${displayName} 전반적인 정보 요약 | 서울경기인천장례정보포털`;
  const description = `${companyname} 위치 안내. 주소: ${address}. ${companyname} 관련 정보, 설명, 비용 상세 안내`;
  const keywords = `${district} ${regionKeyword}, ${companyname}, ${companyname} 정보, ${companyname} 비용, ${companyname} 평균 예상 비용, ${companyname} 자연장, ${companyname} 수목장, ${companyname} 추천, ${companyname} 시설, ${companyname} 위치, ${companyname} 주소, ${displayName}, ${companyname} 후기`;

  return {
    props: {
      defaultFacility: p_facility,
      pageDescription: description,
      pageKeywords: keywords,
      pageOgTitle: title,
      pageOgImage: images[0].url || "",
    },
  };
};

interface FacilityDetailPagProps {
  pageOgTitle: string;
  defaultFacility: DefaultFacility;
}

const FacilityDetailPage = ({
  pageOgTitle,
  defaultFacility,
}: FacilityDetailPagProps) => {
  // const sidoName = FUNERAL_SIDO.get(Number(defaultFacility.sido));
  const sigunguName =
    FUNERAL_SIGUNGU.get(Number(defaultFacility.sido))?.get(
      Number(defaultFacility.sigungu)
    ) || "";

  const facilityPageSchema = buildFacilityPageSchema(defaultFacility);

  const isHidden = excludeFacilities.includes(String(defaultFacility.id));

  return (
    <>
      <Head>
        <title>{pageOgTitle}</title>
      </Head>
      <RichSearch data={facilityPageSchema} />

      <DTypeBreadCrumb
        mainColor={regionColor}
        firstItem={{
          text: `장지 추천`,
          href: isHidden
            ? `${GOI_WEB_URL}/facilities/search/initial/?referrerId=${defaultFacility.id}&utm_source=dogsound`
            : `${GOI_WEB_URL}/match/facility-requests/${defaultFacility.id}/?utm_source=dogsound`,
          event: {
            domain: "dggb",
            path: "facility",
            trigger_and_target: "br_crumb_mth_facil_req",
          },
        }}
        // secondItem={{
        //   text: `${FUNERAL_SIDO.get(Number(defaultParlor.sido))} 장례식장`,
        //   href: `/price/${defaultParlor.sido}/`,
        //   event: {
        //     domain: "dggb",
        //     path: event.path,
        //     trigger_and_target: "br_crumb_sido_prlr_list",
        //   },
        // }}
        // thirdItem={{
        //   text: `${FUNERAL_SIGUNGU.get(Number(defaultParlor.sido))?.get(
        //     Number(defaultParlor.sigungu)
        //   )} 장례식장`,
        //   href: `/price/${defaultParlor.sido}-${defaultParlor.sigungu}/`,
        //   event: {
        //     domain: "dggb",
        //     path: event.path,
        //     trigger_and_target: "br_crumb_sigungu_prlr_list",
        //   },
        // }}
        goiHomeEvent={{
          domain: "dggb",
          path: "facility",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />

      <ParlorHeadSection
        component={
          <>
            <ETypeFacilityMainHead
              status="jangji"
              mainColor={regionColor}
              defaultFacility={defaultFacility}
              title={`${defaultFacility.companyname}`}
              event={{
                domain: "metro",
                path: "facility",
                trigger_and_target: "uv_mth_facil_req",
              }}
            />
          </>
        }
      />

      {isHidden ? (
        <FacilityHiddenNotice
          companyname={defaultFacility.companyname}
          mainColor={regionColor}
          ctaHref={`${GOI_WEB_URL}/facilities/search/initial/?referrerId=${defaultFacility.id}&utm_source=dogsound`}
          event={{
            domain: "metro",
            path: "facility",
            trigger_and_target: "CTA_uv_facil_req",
          }}
        />
      ) : (
        <>
      <BreakLine />
      <DTypeCTA
        mainColor={regionColor}
        text="장지 비용 알아보기"
        companyname={defaultFacility.companyname}
        href={`${GOI_WEB_URL}/match/facility-requests/${defaultFacility.id}/?utm_source=dogsound`}
        event={{
          domain: "metro",
          path: "facility",
          trigger_and_target: "CTA_uv_facil_req",
        }}
      />
      <BreakLine />

      <Stack style={{ background: "white" }}>
        <BTypeTabsFacility
          mainColor={regionColor}
          href={`parlor-place/${defaultFacility.companyname}`}
          selectTab="소개"
          event={{
            domain: "metro",
            path: "facility",
            trigger_and_target: "BType_tab",
          }}
        />
      </Stack>

      <Stack padding="20px 34px">
        <BTypeMap defaultParlor={defaultFacility} />
      </Stack>

      <BTypeFacilityFAQ />
      <FacilityDetailFAQ />
        </>
      )}

      <Stack padding="20px 0px">
        <BTypeFacilityList
          title={`${sigunguName} 주변 장지`}
          defaultHref={"/facility-place"}
          mainColor={regionColor}
          sigungu={defaultFacility.sigungu}
          event={{
            domain: "metro",
            path: "facility",
            trigger_and_target: "uv_facility",
          }}
        />
      </Stack>
    </>
  );
};

const BreakLine = () => {
  return (
    <Box padding="0 20px">
      <Box
        width="100%"
        height="1px"
        style={{ background: colors.gray900 }}
        margin="0 0 20px"
        padding="0 20px"
      />
    </Box>
  );
};

export default FacilityDetailPage;
